<service-icon [type]="icon()" [firewallEnabled]="firewallEnabled()" [active]="true" />

<div>
  <div class="service__title-wrapper" [class.card--clickable]="isAccessible()">
    <svg-icon src="assets/images/icons/status-{{ healthStatus() | status_to_icon }}.svg"></svg-icon>
    @if (isAccessible()) {
      <a [routerLink]="routerLink()">
        <h3 class="service__title">{{ title() }}</h3>
        <svg-icon class="service__title-arrow" src="assets/images/icons/arrow-small-right.svg" />
      </a>
    } @else {
      <h3 class="service__title">{{ title() }}</h3>
    }
  </div>
  <!-- Suppress showing the firewall tag because we indicate firewall via service-icon -->
  <service-tags [tags]="tags()" [firewallEnabled]="false" />
</div>
